import { render } from "./Premis.vue?vue&type=template&id=0cabce7a"
import script from "./Premis.vue?vue&type=script&lang=js"
export * from "./Premis.vue?vue&type=script&lang=js"

import "./Premis.vue?vue&type=style&index=0&id=0cabce7a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__